export const allMaterials: IMaterials = {
  m1: {
    id: 'm1',
    emission: 0,
    metalness: 0,
    roughness: 0,
    specular: 0,
    tint: '#ffffff',
    activeMaps: {
      displacement: true,
      albedo: true,
      ao: true,
      normal: true,
      roughness: true,
    },
  },
};
